// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUpInvoice_wrapper__YPopP","text":"TopUpInvoice_text__iKVse"};